import { CentersListRequest, CentersListResponse } from '../../../types/centers'
import { useApiPostQuery } from '../useApi'

export const useCentersList = (requestData: CentersListRequest = {}) => {
  return useApiPostQuery<CentersListResponse>(
    '/centers/list',
    ['centerList', requestData],
    requestData,
    true
  )
}
